module.exports = __webpack_public_path__ + "static/media/writer-new.ed8e7d6a.png";